import { createAction, handleActions } from 'redux-actions';
import createRequestSaga, {
  createRequestActionTypes,
} from '../../lib/createRequestSaga';
import { takeLatest } from 'redux-saga/effects';

import * as noticeApi from '../../lib/api/notice';


const [LIST_NOTICES, LIST_NOTICES_SUCCESS, LIST_NOTICES_FAILURE] =
  createRequestActionTypes('notice/LIST_NOTICES');
export const listNotices = createAction(
  LIST_NOTICES,
  (searchData) => searchData,
);
const listNoticesSaga = createRequestSaga(
  LIST_NOTICES,
  noticeApi.getNotices,
);

const UNLOAD_NOTICES = 'notice/UNLOAD_NOTICES';
export const unloadNotices = createAction(UNLOAD_NOTICES);

export function* noticesSaga() {

  yield takeLatest(LIST_NOTICES, listNoticesSaga);
}

const initialState = {
  notices: null,
  error: null,
};

const notices = handleActions(
  {

    [LIST_NOTICES_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      notices: data.list.map((notice) => ({
        id: notice.wrUuid,
        wrUuid: notice.wrUuid,
        wrTitle: notice.wrTitle,
        wrTyp: notice.wrTyp,// 게시물 종류
        wrContent: notice.wrContent,
        wrFileCnt: notice?.wrFileCnt,
        wrfileUrl: notice?.wrFileUrl,
        wrStartDt: notice.wrStartDt,
        wrEndDt: notice.wrEndDt,
        useYn: notice.useYn === 'Y' ? true : false,
        crtUsr: notice.crtUsr,
        crtNm: notice.crtNm,
        crtDt: notice.crtDt,
        cngUsr: notice.cngUsr,
        cngNm: notice.cngNm,
        cngDt: notice.cngDt,
      })),
      error: null,
    }),
    [LIST_NOTICES_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error: error,
    }),
    [UNLOAD_NOTICES]: () => initialState
  },
  initialState,
);

export default notices;
